import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import http from '../services/http';
import { Editor } from '@tinymce/tinymce-react';
import Navbar from '../../components/base/Navbar';
import Footer from '../../components/base/Footer';

const months = [
    "Januar", "Februar", "März", "April", "Mai", "Juni",
    "Juli", "August", "September", "Oktober", "November", "Dezember"
];

const NewsletterForm = () => {
    const { year, month } = useParams();
    const navigate = useNavigate();
    const [content, setContent] = useState("");
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        http.get(`/api/admin/newsletter/${year}/${month}`)
            .then(res => {
                  setContent(res.data?.content ?? "");
                  setIsVisible(!!res.data?.visible);
            })
            .catch(() => { setContent(""); setIsVisible(false); });
    }, [year, month]);

    const saveNewsletter = async () => {
        await http.put(`/api/admin/newsletter/${year}/${month}`, { content, visible: isVisible });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        await saveNewsletter();
        navigate(`/admin/newsletter/${year}`);
    };

    const handleCancel = async (e) => {
        e.preventDefault();
        navigate(`/admin/newsletter/${year}`);
    };

    return (
        <div className="bg-gray-200 pt-24">
            <Navbar />
            <form onSubmit={handleSubmit} onCancel={handleCancel} className="p-6 max-w-7xl mx-auto">
                <h1 className="text-2xl font-bold mb-4">
                    Newsletter {months[month - 1]} {year}
                </h1>
                <Editor
                    apiKey="4pik09e86b744unov8w2hb3x3lasqfky2l29grw14esf8lpf"
                    value={content}
                    onEditorChange={setContent}
                    init={{
                        height: 600,
                        width: 1200,
                        menubar: true,
                        plugins: [
                            'advlist autolink lists link image charmap print preview anchor',
                            'searchreplace visualblocks code fullscreen',
                            'insertdatetime media table paste code help wordcount',
                        ],
                        toolbar: 'undo redo | formatselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | removeformat | help',
                    }}
                />
                <div className="mt-4">
                    <label>
                        <input
                            type="checkbox"
                            checked={isVisible}
                            onChange={() => setIsVisible(!isVisible)}
                        />{" "}
                        Sichtbar auf der öffentlichen Seite
                    </label>
                </div>
                <button type="submit" className="mt-4 bg-blue-500 text-white px-5 py-2 rounded hover:ring-2">
                    Speichern
                </button>
                <button type="button" onClick={handleCancel} className="mt-4 ml-2 bg-red-700 text-white px-5 py-2 rounded hover:ring-2">
                    Abbrechen
                </button>
            </form>
            <Footer />
        </div>
    );
};

export default NewsletterForm;
